module.exports = __webpack_public_path__ + "static/media/AmaniFooter.302da751.png";